import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const formaPagamento = (filtro = {}) => {    
    return async dispatch => {
        dispatchpending(dispatch);
        try{
            const response = await axios.get('regtron/pedidos/formaspagto/pesquisa',
                {
                    headers:{
                        Accept: 'application/json',
                        Authorization: `Bearer ${getToken()}`
                    },
                    params:{
                        ...filtro
                    }
                }
            );
            
            dispatchresponse(dispatch,response.data,types.PRODUTOS.FORMA_PAGAMENTO);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch,error);
        }
    }
}
